import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4806e2c8")

_pushScopeId("data-v-4806e2c8")
const _hoisted_1 = { class: "h-full pb-12" }
const _hoisted_2 = { class: "w-6 h-6 mr-2" }
const _hoisted_3 = { class: "ml-2 capitalize" }
const _hoisted_4 = {
  key: 0,
  class: "ml-16 border-l"
}
const _hoisted_5 = { class: "w-6 h-6 mr-2" }
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = {
  key: 0,
  class: "border-l ml-14"
}
const _hoisted_8 = { class: "ml-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_component = _resolveComponent("icon-component")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.chapters, (chapter, chapterIndex) => {
      return (_openBlock(), _createBlock("div", {
        key: chapterIndex,
        "data-testid": `chapter-div-${chapter.title}`
      }, [
        _createVNode("button", {
          class: ["flex items-center w-full p-2 px-6 mb-1 text-left border-l-4 border-transparent hover:bg-background focus:outline-none", { active: _ctx.isActiveChapter(chapter) }],
          onClick: _withModifiers(($event: any) => (_ctx.handleChapterClick(chapter)), ["stop"]),
          onDblclick: ($event: any) => (_ctx.handleChapterToggle(chapter)),
          "data-testid": `chapter-button-${chapter.title}`
        }, [
          _createVNode("div", _hoisted_2, [
            (chapter.topics && chapter.topics.length)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "flex items-center justify-center w-full h-full focus:outline-none",
                  onClick: ($event: any) => (_ctx.handleChapterToggle(chapter)),
                  "data-testid": `chapter-expand-button-${chapter.title}`
                }, [
                  _withDirectives(_createVNode(_component_icon_component, {
                    icon: _ctx.Icon.CHEVRON_DOWN
                  }, null, 8, ["icon"]), [
                    [_vShow, _ctx.isOpenChapter(chapter)]
                  ]),
                  _withDirectives(_createVNode(_component_icon_component, {
                    icon: _ctx.Icon.CHEVRON_RIGHT
                  }, null, 8, ["icon"]), [
                    [_vShow, !_ctx.isOpenChapter(chapter)]
                  ])
                ], 8, ["onClick", "data-testid"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_icon_component, {
            icon: _ctx.Icon.DOCUMENT
          }, null, 8, ["icon"]),
          _createVNode("div", _hoisted_3, _toDisplayString(chapter.title), 1)
        ], 42, ["onClick", "onDblclick", "data-testid"]),
        (_ctx.isOpenChapter(chapter))
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(chapter.topics, (topic, topicIndex) => {
                return (_openBlock(), _createBlock("div", { key: topicIndex }, [
                  _createVNode("button", {
                    class: ["flex items-center w-full p-2 pl-4 mb-1 text-left border-l-4 border-transparent focus:outline-none hover:bg-background", {
              active: _ctx.isActiveTopic(topic) && _ctx.isActiveChapter(chapter)
            }],
                    onClick: ($event: any) => (_ctx.handleTopicClick(chapter, topic)),
                    onDblclick: ($event: any) => (_ctx.handleTopicToggle(topic)),
                    "data-testid": `topic-button-${topic.title}`
                  }, [
                    _createVNode("div", _hoisted_5, [
                      (topic.events && topic.events.length)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            class: "flex items-center justify-center w-full h-full focus:outline-none",
                            onClick: ($event: any) => (_ctx.handleTopicToggle(topic)),
                            "data-testid": `topic-expand-button-${topic.title}`
                          }, [
                            _withDirectives(_createVNode(_component_icon_component, {
                              icon: _ctx.Icon.CHEVRON_DOWN
                            }, null, 8, ["icon"]), [
                              [_vShow, _ctx.isOpenTopic(topic)]
                            ]),
                            _withDirectives(_createVNode(_component_icon_component, {
                              icon: _ctx.Icon.CHEVRON_RIGHT
                            }, null, 8, ["icon"]), [
                              [_vShow, !_ctx.isOpenTopic(topic)]
                            ])
                          ], 8, ["onClick", "data-testid"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_icon_component, {
                      icon: _ctx.Icon.DOCUMENT,
                      class: ""
                    }, null, 8, ["icon"]),
                    _createVNode("div", _hoisted_6, _toDisplayString(topic.title), 1)
                  ], 42, ["onClick", "onDblclick", "data-testid"]),
                  (_ctx.isOpenTopic(topic))
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(topic.events, (eventName, eventIndex) => {
                          return (_openBlock(), _createBlock("button", {
                            class: ["flex items-center w-full p-2 pl-4 mb-1 text-left border-l-4 border-transparent focus:outline-none hover:bg-background", { active: _ctx.isActiveEvent(eventName) }],
                            key: eventIndex,
                            onClick: ($event: any) => (_ctx.handleEventClick(chapter, topic, eventName)),
                            "data-testid": `event-button-${eventIndex}`
                          }, [
                            _createVNode(_component_icon_component, {
                              icon: _ctx.Icon.DOCUMENT,
                              class: ""
                            }, null, 8, ["icon"]),
                            _createVNode("div", _hoisted_8, _toDisplayString(eventName), 1)
                          ], 10, ["onClick", "data-testid"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 8, ["data-testid"]))
    }), 128))
  ]))
})